<script>
  import { _ } from "svelte-i18n";

  export let maincolor = "#2563eb";
  export let darkercolor = "#1e40af";

  export let id;
  export let question = "";
  export let review = "";
  export let reviewIsValid = null;
  export let charsAreValid = null;
  export let onFreeTextChange = () => {};

  function handleChange() {
    onFreeTextChange(id, review);
  }

  let charsLeft = 280;

  $: charsLeft = 280 - review.length;

  $: if (charsLeft >= 0) {
    charsAreValid = true;
  } else {
    charsAreValid = false;
  }

  $: if (review.length > 0 && charsLeft >= 0) {
    reviewIsValid = true;
  }
</script>

<div>
  <p class="mt-45px mb-4 text-20px ">{question}</p>
  {#if reviewIsValid == false}
    <div class="mb-5px italic text-red-600 text-16px">
      {$_("JUSTIFY_SELECTION")}
    </div>
  {/if}

  <textarea
    class="tukanga-input overflow-hidden {charsLeft < 0 ||
    reviewIsValid == false
      ? '!border-red-600'
      : ''}"
    bind:value={review}
    on:change={handleChange}
    rows="3"
    name="review"
    spellcheck="false" />

  <div class="text-16px mt-10px italic">
    {#if charsLeft >= 0}
      {#if charsLeft != 1}
        <div class="text-gray-400">
          {charsLeft}
          {$_("CHARS").toLowerCase()}
          {$_("REMAINING_PLURAL").toLowerCase()}
        </div>
      {:else}
        <div class="text-gray-400">
          {charsLeft}
          {$_("CHAR").toLowerCase()}
          {$_("REMAINING_SINGULAR").toLowerCase()}
        </div>
      {/if}
    {:else}
      <div class="text-red-600">{$_("EXCEED_CHARS")}</div>
    {/if}
  </div>
</div>

<style windi:preflights:global windi:safelist:global>
  .tukanga-input {
    border-color: #ccc;
    border: 1px solid #666;
    font-family: inherit;
    @apply text-left bg-white p-15px w-full resize-none text-20px  rounded-4px box-border;
  }

  .tukanga-input:focus {
    box-shadow: 0 0 10px #719ece;
    border: 1px solid #666;

    @apply border-$maincolor text-left outline-none;
  }
</style>
